// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"fU-z","categoryName":"gU-z","categoryNameSearchHeader":"hU-z","categoryContent":"iU-z","bottomAligned":"jU-z","image":"kU-z","imageNoBackground":"lU-z"};